import { createContext, useContext } from 'react';

import { MAIN_PLAYER_INSTANCE_KEY } from '@/modules/common/components/Player/constants';

import logger from '@/modules/common/helpers/logger';

/**
 * @type {Object.<string, React.Context<PlayerWidget>>}
 */
const providers = {};
export const setContext = (instanceKey) => {
  if (!providers[instanceKey]) {
    providers[instanceKey] = createContext(/** @type {PlayerWidget} */ {});
  }
};
export const getContext = (instanceKey) => providers[instanceKey];
export const deleteContext = (instanceKey) => {
  delete providers[instanceKey];
};

export const getCustomWidgetId = (instanceKey) => `${instanceKey}==[${(Date.now() + Math.random()).toString(36)}]`;

export const usePlayerWidget = (instanceKey) => {
  let targetContext = providers[instanceKey];

  if (!targetContext) {
    logger.error(`Please add PlayerProvider for instance "${instanceKey}"`);

    targetContext = providers[MAIN_PLAYER_INSTANCE_KEY];
  }

  return useContext(targetContext);
};

export const mainPlayerWidget = {
  current: null,
};

export const setMainPlayerWidget = (widget) => {
  mainPlayerWidget.current = widget;
};

export const getMainPlayerWidget = () => mainPlayerWidget.current;
